import { useState, useEffect, act } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import MoreHorizOutlinedIcon from "@mui/icons-material/MoreHorizOutlined";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Divider from "@mui/material/Divider";
import Switch from "@mui/material/Switch";
import AddIcon from "@mui/icons-material/Add";
import DownloadIcon from '@mui/icons-material/Download';
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import "../../../Assets/Styles/Containers/_header.scss";
import { editCategory, editLine, getTemplateListCall, reorderCategory, reorderLines, swapInspectionDetailsCall } from "../../Redux/Actions/CommonActions";
import AddTemplateModal from "./AddTemplateModal";
import { ApiCallDuplicateCategory, ApiCallDuplicateLine, getDeletedTemplateData, UpdateTemplateDataSpecific } from "../../Helpers/ApiCall";
import { TbPrinterOff } from "react-icons/tb";
import { MdOutlineModeEditOutline } from "react-icons/md";
import EditCategoryModal from "../../Pages/Inspection/EditCategoryModal";
import { GetUTCTime } from "../../Helpers/GetUTCTime";
import { cleanPayloadOnCategoryLevel, cleanPayloadOnCategoryLinesLevel, cleanPayloadForTemplate, filterObjectsUptoCategory } from "../../Helpers/HelperFunctions";
import { AiOutlineCopy } from "react-icons/ai";
import { RiDeleteBin6Line } from "react-icons/ri";
import DeleteConfirmationDialog from "../../Common/Alert/DeleteConfirmationDialog";
import { IoMdColorPalette } from "react-icons/io";
import { MdOutlineLocalPrintshop } from "react-icons/md";
import AssignColorIndicatorModal from "../../Pages/Inspection/AssignColorIndicatorModal";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import { RenameTemplate } from "../../../Assets/Svg/Svg";
import FromExistingTemplate from "../../Pages/ZeroState/FromExistingTemplate";
import toast from "react-hot-toast";

const Header = ({ title, titleSuffix, action, categoryData, stickyHeader, assosiatedCategoryColors, assosiatedLineColor, lineData }) => {
  const [addTemplateModal, setAddTemplateModal] = useState(false);
  const [deleteTemplateModal, setDeteleteTemplateModal] = useState(false);
  const [templateList, setTemplateList] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [editCategoryName, setEditCategoryName] = useState("");
  const [showEditCategoryModal, setShowEditCategoryModal] = useState(false);
  const [inspectionResponse, setInspectionResponse] = useState();
  const [deleteCategoryModal, setShowDeleteModal] = useState(false);
  const [assignColorIndicatorModal, setAssignColorIndicatorModal] = useState(false);
  const [assignColorIndicatorCategory, setAssignColorIndicatorCategory] = useState();
  const [assignColorIndicatorLine, setAssignColorIndicatorLine] = useState();
  const [categoryMenuAnchorEl, setCategoryMenuAnchorEl] = useState(null);
  const [showExistingTemplateModal, setShowExistingTemplateModal] = useState(false);
  const openExistingTemplateModal = () => { setShowExistingTemplateModal(true); handleClose(); }
  const closeExistingTemplateModal = () => setShowExistingTemplateModal(false);

  const dispatch = useDispatch();
  const location = useLocation();

  let templateId = location?.state?.template_id;
  const navigate = useNavigate();
  const path = location.pathname.split("/");
  const open = Boolean(anchorEl);
  const storeData = useSelector((state) => state.CommonReducer);
  const inspectionId = storeData?.inspectionData?.data?.inspection_id;
  let templateData = storeData?.inspectionData?.data?.inspectiontemplates?.find((template) => template.template_id === templateId);
  const IsPdf = templateData?.is_pdf_template;
  const assignColorList = storeData?.inspectionData?.data?.inspectorFlagList?.filter((item) => item.is_deleted !== 1) || [];
  const isTexas = templateData?.is_texas
  useEffect(() => {
    if (storeData.inspectionData) {
      setInspectionResponse(storeData.inspectionData?.data);
    }
  }, [storeData.inspectionData]);

  const handleConfirmEditCategory = async (editedName, type) => {
    let templateIndex = inspectionResponse?.inspectiontemplates?.findIndex((itm) => itm.template_id === templateId);
    let prevData = JSON.parse(JSON.stringify(inspectionResponse));
    if (type === "category") {
      let categoryIndex = inspectionResponse?.inspectiontemplates[templateIndex]?.categories?.findIndex((itm) => itm.uuid === categoryData.uuid);
      delete prevData?.report_media_library_files;
      prevData.inspectiontemplates[templateIndex].categories[categoryIndex].prompt = editedName;
      prevData.inspectiontemplates[templateIndex].categories[categoryIndex].updated_at = await GetUTCTime();
      let filteredObject = cleanPayloadOnCategoryLevel(prevData, templateIndex, categoryIndex);
      UpdateTemplateDataSpecific(dispatch, prevData, filteredObject);
      setAnchorEl(null);
      setShowEditCategoryModal(false);
    } else if (type === "template") {
      if (editedName !== "") {
        prevData.inspectiontemplates[templateIndex].name = editedName;
        prevData.inspectiontemplates[templateIndex].updated_at = await GetUTCTime();
        prevData.inspectiontemplates[templateIndex].isTemplateNameChanged = true;
        let newObject = cleanPayloadForTemplate(prevData, templateIndex);
        UpdateTemplateDataSpecific(dispatch, prevData, newObject);
        setShowEditCategoryModal(false);
      } else {
        toast.error("Template name cannot be empty");
      }
    } else if (type === "line") {
      let categoryIndex = inspectionResponse?.inspectiontemplates[templateIndex]?.categories?.findIndex((itm) => itm.uuid === categoryData.uuid);
      let lineIndex = inspectionResponse?.inspectiontemplates[templateIndex]?.categories[categoryIndex]?.lines?.findIndex((itm) => itm.uuid === lineData.uuid);
      delete prevData?.report_media_library_files;
      prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].prompt = editedName;
      prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].updated_at = await GetUTCTime();
      let filteredObject = cleanPayloadOnCategoryLinesLevel(prevData, templateIndex, categoryIndex, lineIndex);
      UpdateTemplateDataSpecific(dispatch, prevData, filteredObject);
      setAnchorEl(null);
      setShowEditCategoryModal(false);
    }
  };

  const ḥandleDuplicateCategory = async (category, line, action) => {
    const formData = {
      guid: sessionStorage.getItem("guid"),
      inspection_id: storeData.inspectionData?.data?.inspection_id,
      template_id: templateId,
      category_uuid: category.uuid,
      inspection_guid: storeData.inspectionData?.data?.guid,
    };
    if (action === "line") await ApiCallDuplicateLine(dispatch, { ...formData, line_uuid: line?.uuid });
    else await ApiCallDuplicateCategory(dispatch, formData);
    setAnchorEl(null);
  };

  const handleToggleCompleted = async (category, line, action) => {
    let templateIndex = inspectionResponse?.inspectiontemplates?.findIndex((itm) => itm.template_id === templateId);
    let categoryIndex = inspectionResponse?.inspectiontemplates[templateIndex]?.categories?.findIndex((itm) => itm.uuid === category.uuid);
    let prevData = JSON.parse(JSON.stringify(inspectionResponse));
    delete prevData?.report_media_library_files;
    if (action === "line") {
      let lineIndex = inspectionResponse?.inspectiontemplates[templateIndex]?.categories[categoryIndex]?.lines?.findIndex((itm) => itm.uuid === line.uuid);
      const isCompleted = line?.is_completed === 0 || line?.is_completed === false ? true : false;
      prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].is_completed = isCompleted;
      prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].updated_at = await GetUTCTime();
    } else {
      const isCompleted = category?.is_completed === 0 || category?.is_completed === false ? true : false;
      const currentUpdatedAt = await GetUTCTime();
      prevData.inspectiontemplates[templateIndex].categories[categoryIndex].is_completed = isCompleted;
      prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines?.forEach((line) => {
        line.is_completed = isCompleted;
        line.updated_at = currentUpdatedAt;
      });
    }
    prevData.inspectiontemplates[templateIndex].categories[categoryIndex].updated_at = await GetUTCTime();
    let filteredObject = cleanPayloadOnCategoryLinesLevel(prevData, templateIndex, categoryIndex);
    UpdateTemplateDataSpecific(dispatch, prevData, filteredObject);
    setAnchorEl(null);
  };

  const handleConfirmDeleteCategory = async (categoryData, lineData, action) => {
    let templateIndex = inspectionResponse?.inspectiontemplates?.findIndex((itm) => itm.template_id === templateId);
    let categoryIndex = inspectionResponse?.inspectiontemplates[templateIndex]?.categories?.findIndex((itm) => itm.uuid === categoryData.uuid);
    let prevData = JSON.parse(JSON.stringify(inspectionResponse));
    delete prevData?.report_media_library_files;
    if (action === "line") {
      let lineIndex = inspectionResponse?.inspectiontemplates[templateIndex]?.categories[categoryIndex]?.lines?.findIndex((itm) => itm.uuid === lineData.uuid);
      prevData.inspectiontemplates[templateIndex].categories[categoryIndex].updated_at = await GetUTCTime();
      prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].is_deleted = 1;
      prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].updated_at = await GetUTCTime();
      let filteredObject = cleanPayloadOnCategoryLinesLevel(prevData, templateIndex, categoryIndex, lineIndex);
      UpdateTemplateDataSpecific(dispatch, prevData, filteredObject);
      navigate(-1)
    } else {
      prevData.inspectiontemplates[templateIndex].categories[categoryIndex].is_deleted = 1;
      prevData.inspectiontemplates[templateIndex].categories[categoryIndex].updated_at = await GetUTCTime();
      let filteredObject = cleanPayloadOnCategoryLevel(prevData, templateIndex, categoryIndex);
      UpdateTemplateDataSpecific(dispatch, prevData, filteredObject);
      navigate("/inspection", {
        state: {
          ...inspectionResponse?.inspectiontemplates[templateIndex], template_id: templateId, tempIndex: templateIndex
        }
      });
    }
    setShowDeleteModal(false);
    setAnchorEl(null);
  };

  const handleTogglePrintable = async (category, line, action) => {
    let templateIndex = inspectionResponse?.inspectiontemplates?.findIndex((itm) => itm.template_id === templateId);
    let categoryIndex = inspectionResponse?.inspectiontemplates[templateIndex]?.categories?.findIndex((itm) => itm.uuid === category.uuid);
    let prevData = JSON.parse(JSON.stringify(inspectionResponse));
    delete prevData?.report_media_library_files;
    if (action === "line") {
      let lineIndex = inspectionResponse?.inspectiontemplates[templateIndex]?.categories[categoryIndex]?.lines?.findIndex((itm) => itm.uuid === line.uuid);
      const isPrintable = line?.is_printable === 0 || line?.is_printable === false ? true : false;
      prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].is_printable = isPrintable;
      prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].updated_at = await GetUTCTime();
    } else {
      const isPrintable = category?.is_printable === 0 || category?.is_printable === false ? true : false;
      const currentUpdatedAt = await GetUTCTime();
      prevData.inspectiontemplates[templateIndex].categories[categoryIndex].is_printable = isPrintable;
      prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines?.forEach((line) => {
        line.is_printable = isPrintable;
        line.updated_at = currentUpdatedAt;
      });
    }
    prevData.inspectiontemplates[templateIndex].categories[categoryIndex].updated_at = await GetUTCTime();
    let filteredObject = cleanPayloadOnCategoryLinesLevel(prevData, templateIndex, categoryIndex);
    UpdateTemplateDataSpecific(dispatch, prevData, filteredObject);
    setAnchorEl(null);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    deletedTemplate();
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleReorder = (action) => {
    if (action === "categories") {
      dispatch(reorderCategory(true));
    } else if (action === "category") {
      dispatch(reorderLines(true));
    }
  };
  const handleEdit = (action) => {
    if (action === "categories") {
      dispatch(editCategory(true));
    } else if (action === "category") {
      dispatch(editLine(true));
    }
  };
  const handleEditComplete = () => {
    if (action === "categories") {
      dispatch(editCategory(false));
    } else if (action === "category") {
      dispatch(editLine(false));
    }
  };
  const handleReorderComplete = () => {
    if (action === "categories") {
      dispatch(reorderCategory(false));
    } else if (action === "category") {
      dispatch(reorderLines(false));
    }
  };

  const handleAddTemplate = () => {
    const { data } = storeData?.defaultTemplateList;
    setTemplateList(data);
    setAddTemplateModal(true);
    handleClose();
  };

  const handleDeleteTemplate = () => {
    handleClose();
    setDeteleteTemplateModal(true);
  };

  const handleBackAction = () => {
    if (action === "category") {
      if (!storeData?.editLine && !storeData?.reorderLines) {
        navigate(-1);
      }
      dispatch(editCategory(false));
      dispatch(editLine(false));
      dispatch(reorderLines(false));
      dispatch(reorderCategory(false));
    } else if (action === "categories") {
      dispatch(editCategory(false));
      dispatch(editLine(false));
      dispatch(reorderCategory(false));
      dispatch(reorderLines(false));
    } else {
      navigate(-1);
    }
  };

  const deletedTemplate = () => {
    let formData = { inspection_id: inspectionId };
    getDeletedTemplateData(dispatch, formData); 
    dispatch(getTemplateListCall(sessionStorage.getItem("guid")));
  };

  const handleEditCategory = (category, type) => {
    setAnchorEl(null);
    setShowEditCategoryModal(true);
    setEditCategoryName(type === "category" || type === "line" ? category?.prompt : templateData?.name);
  };
  const handleCloseEditAlert = () => {
    setShowEditCategoryModal(false);
  }
  const handleCloseDeleteAlert = () => {
    setShowDeleteModal(false);
  };
  const handleAssignColor = () => {
    setAssignColorIndicatorModal(true);
  };

  const handleOpenAssignColor = (category) => {
    setAssignColorIndicatorModal(true);
    setAssignColorIndicatorCategory(category);
    setAssignColorIndicatorLine(lineData);
  }

  return (
    <div
      id="sticky_header"
      className={stickyHeader ? "sticky_header" : "header"}
      style={{
        backgroundColor: (categoryData?.is_printable === 0 || categoryData?.is_printable === false) && categoryData?.is_inspection_details !== 1 ? "#E8E8E8" : undefined,
      }}
    >
      <AddTemplateModal
        addTemplateModal={addTemplateModal}
        setAddTemplateModal={setAddTemplateModal}
        deleteTemplateModal={deleteTemplateModal}
        setDeteleteTemplateModal={setDeteleteTemplateModal}
        templateList={templateList}
        storeData={storeData}
      />
      <EditCategoryModal open={showEditCategoryModal} handleClose={handleCloseEditAlert} editCategoryName={editCategoryName} setEditCategoryName={setEditCategoryName} handleConfirmEditCategory={handleConfirmEditCategory} type={action === "line" ? "line" : action !== "category" ? "template" : "category"} />
      <DeleteConfirmationDialog
        open={deleteCategoryModal}
        handleClose={handleCloseDeleteAlert}
        title={`Delete ${action === "line" ? "line" : "category"}`}
        contentText={`Are you sure you want to delete the ${action === "line" ? "line" : "category"} ${action === "line" ? lineData?.prompt : categoryData?.prompt}?`}
        cancelBtnTitle={"Cancel"}
        cancelBtnAction={handleCloseDeleteAlert}
        submitBtnTitle={"Delete"}
        submitBtnAction={() => handleConfirmDeleteCategory(categoryData, lineData, action)}
      />
      {assignColorIndicatorModal && (
        <AssignColorIndicatorModal
          assignColorIndicatorModal={assignColorIndicatorModal}
          setAssignColorIndicatorModal={setAssignColorIndicatorModal}
          handleAssignColor={handleAssignColor}
          assignColorList={assignColorList}
          templateId={templateId}
          assignColorIndicatorCategory={assignColorIndicatorCategory}
          setAssignColorIndicatorCategory={setAssignColorIndicatorCategory}
          templateData={templateData}
          setCategoryMenuAnchorEl={setCategoryMenuAnchorEl}
          action={action}
          setAnchorEl={setAnchorEl}
          assignColorIndicatorLine={assignColorIndicatorLine}
          setAssignColorIndicatorLine={setAssignColorIndicatorLine}
        />
      )}
      <FromExistingTemplate open={showExistingTemplateModal} handleClose={closeExistingTemplateModal} />
      <span className="header__name" style={{ display: "flex", alignItems: "center", width: "100%" }}>
        <span className="header__title" style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          {/* Back button */}
          {(location.pathname !== "/inspection" || storeData?.editCategory || storeData?.reorderCategory) &&
            location.pathname !== "/review" &&
            location.pathname !== "/" &&
            location.pathname !== "/report_media_library" && <ArrowBackIcon sx={{ zIndex: 9, cursor: "pointer" }} id="back_button" onClick={handleBackAction} />}
          {/* Title */}
          <span style={{ display: "inline-flex", alignItems: "center", gap: "8px", }}>
            {title !== null ? title : "Untitled"}
            {titleSuffix && (
              <span style={{ fontSize: "13px", fontWeight: 400, color: "#757575",marginTop: "3px"}}>{titleSuffix}</span>
            )}
            {(categoryData?.is_printable === 0 || categoryData?.is_printable === false || (action === "line" && lineData?.is_printable === 0 || lineData?.is_printable === false)) && categoryData?.is_inspection_details !== 1 && <TbPrinterOff className="print_off" />}
          </span>
          {action === "line" ?
            assosiatedLineColor?.map((color, index) => (
              <span
                key={index}
                style={{
                  display: "inline-block",
                  width: "12px",
                  height: "12px",
                  borderRadius: "50%",
                  backgroundColor: color,
                }}
              ></span>))
            : assosiatedCategoryColors?.map((color, index) => (
              <span
                key={index}
                style={{
                  display: "inline-block",
                  width: "12px",
                  height: "12px",
                  borderRadius: "50%",
                  backgroundColor: color,
                }}
              ></span>
            ))
          }
        </span>
      </span>
      <div className="header__action">
        {path[1] !== "" && path[1] !== "review" && path[1] !== "report_media_library" && action !== "pdfElement" ? (
          storeData?.editCategory || storeData?.editLine || storeData?.reorderCategory || storeData?.reorderLines ? (
            <span
              className="header_info_text"
              onClick={() => {
                handleEditComplete();
                handleReorderComplete();
              }}
              id="done_button"
            >
              Done
            </span>
          ) : categoryData?.is_inspection_details === 2 ? (
            null
          ) : (
            <Button id="ellipsis-button" aria-controls={open ? "basic-menu" : undefined} aria-haspopup="true" aria-expanded={open ? "true" : undefined} onClick={handleClick}>
              <MoreHorizOutlinedIcon />
            </Button>
          )
        ) : null}
        <Menu
          id="header-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{ "aria-labelledby": "basic-button", }}
          className="header__menu"
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
          sx={{
            "& .MuiPaper-root": {
              boxShadow: "rgba(0, 0, 0, 0.01) 0px 4px 4px",
              backgroundColor: "#ffffff",
              borderRadius: "8px",
              border: "1px solid #e0e0e0",
              padding: "8px 0",
              width: "276px",
            },
          }}
        >
          {action !== "categories" && categoryData?.is_inspection_details !== 1 && <MenuItem onClick={() => handleEditCategory(action === "line" ? lineData : categoryData, action === "line" ? "line" : "category")} style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <MdOutlineModeEditOutline style={{ fontSize: "20px", color: "#555555" }} />
            <span style={{ fontWeight: "400  !important", fontSize: "14px  !important", color: "#3b3b3b !important" }}>{`Edit ${action === "line" ? "line" : "category"} name`}</span>
          </MenuItem>}
          {action !== "categories" && categoryData?.is_inspection_details !== 1 && (
            <MenuItem onClick={() => ḥandleDuplicateCategory(categoryData, lineData, action)} style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <AiOutlineCopy style={{ fontSize: "20px", color: "#555555" }} />
              <span style={{ fontWeight: "400  !important", fontSize: "14px  !important", color: "#3b3b3b !important" }}>{`Duplicate ${action === "line" ? "line" : "category"}`}</span>
            </MenuItem>
          )}
          {/* )} */}
          {action !== "categories" && categoryData?.is_inspection_details !== 1 && <Divider sx={{ margin: "8px 0" }} />}
          {(!IsPdf && action !== "line") && (
            <MenuItem
              onClick={() => {
                handleClose();
                handleReorder(action);
              }}
              style={{ display: "flex", alignItems: "center", gap: "10px" }}
              id="reorder_list"
            >
              <SwapHorizIcon fontSize="small" style={{ fontSize: "20px", color: "#555555", transform: "rotate(90deg)" }} />
              <span style={{ fontWeight: "400  !important", fontSize: "14px  !important", color: "#3b3b3b !important" }}>{`Reorder ${action === "category" ? "lines" : action}`}</span>
            </MenuItem>
          )}
          {(!IsPdf && action !== "line") && (
            <MenuItem
              onClick={() => {
                handleClose();
                handleEdit(action);
              }}
              style={{ display: "flex", alignItems: "center", gap: "10px" }}
              id="edit_list"
            >
              <MdOutlineModeEditOutline style={{ fontSize: "20px", color: "#555555" }} />
              <span style={{ fontWeight: "400  !important", fontSize: "14px  !important", color: "#3b3b3b !important" }}>{`Edit ${action === "category" ? "lines" : action}`}</span>
            </MenuItem>
          )}
          {action === "categories" && (
            <MenuItem onClick={handleAddTemplate} id="add_template_in_list" style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <AddIcon fontSize="small" />
              <span style={{ fontWeight: "400  !important", fontSize: "14px  !important", color: "#3b3b3b !important" }}>Add template</span>
            </MenuItem>
          )}
          {action === "categories" && (
            <MenuItem onClick={openExistingTemplateModal} id="add_template_in_list" style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <DownloadIcon fontSize="small" />
              <span style={{ fontWeight: "400  !important", fontSize: "14px  !important", color: "#3b3b3b !important" }}>Import from previous order</span>
            </MenuItem>
          )}
          {action === "categories" && !IsPdf && !isTexas && (
            <MenuItem onClick={() => handleEditCategory(categoryData, "template")} id="add_template_in_list" style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <RenameTemplate style={{ fontSize: "20px", color: "#555555" }} />
              <span style={{ fontWeight: "400  !important", fontSize: "14px  !important", color: "#3b3b3b !important" }}>Rename template</span>
            </MenuItem>
          )}
          {action === "categories" && (
            <MenuItem onClick={handleDeleteTemplate} id="remove_template_from_list" style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <DeleteForeverIcon fontSize="small" />
              <span style={{ fontWeight: "400  !important", fontSize: "14px  !important", color: "#3b3b3b !important" }}>Remove template </span>
            </MenuItem>
          )}
          {categoryData?.is_inspection_details === 2 ? (
            ""
          ) : (
            <>
              {action !== "categories" && categoryData?.is_inspection_details !== 1 && <MenuItem style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "8px 16px" }}>
                <span style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                  <DoneAllIcon style={{ fontSize: "20px", color: "#555555" }} />
                  <span style={{ fontWeight: "400  !important", fontSize: "14px  !important", color: "#3b3b3b !important" }}>{action === "line" ? `Mark line complete` : `Mark all lines completed`}</span>
                </span>
                <Switch size="small" checked={action === "line" ? lineData?.is_completed : categoryData?.is_completed} onChange={() => handleToggleCompleted(categoryData, lineData, action)} />
              </MenuItem>}
            </>
          )}
          {templateData?.is_texas !== 1 && action !== "categories" && categoryData?.is_inspection_details !== 1 && (
            <>
              <MenuItem style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "8px 16px" }}>
                <span style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                  <MdOutlineLocalPrintshop style={{ fontSize: "20px", color: "#555555" }} />
                  <span style={{ fontWeight: "400  !important", fontSize: "14px  !important", color: "#3b3b3b !important" }}>Print in report</span>
                </span>
                <Switch size="small" checked={action === "line" ? lineData?.is_printable : categoryData?.is_printable} onChange={() => handleTogglePrintable(categoryData, lineData, action)} />
              </MenuItem>
              <Divider sx={{ margin: "8px 0" }} />
            </>
          )}
          {action !== "categories" && categoryData?.is_inspection_details !== 1 && <MenuItem onClick={() => handleOpenAssignColor(categoryData, lineData, action)} style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <IoMdColorPalette style={{ fontSize: "20px", color: "#555555" }} />
            <span style={{ fontWeight: "400  !important", fontSize: "14px  !important", color: "#3b3b3b !important" }}>Assign color</span>
          </MenuItem>}
          {action !== "categories" && categoryData?.is_inspection_details !== 1 && <Divider sx={{ margin: "8px 0" }} />}
          {action !== "categories" && categoryData?.is_inspection_details !== 1 && <MenuItem
            onClick={() => setShowDeleteModal(true)}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              fontWeight: "400  !important",
              fontSize: "14px !important",
            }}
          >
            <RiDeleteBin6Line style={{ fontSize: "20px", color: "#D53D3D" }} />
            <span>{`Delete ${action === "line" ? "line" : "category"}`}</span>
          </MenuItem>}
        </Menu>
      </div>
    </div>
  );
};

export default Header;
